import { render, staticRenderFns } from "./CMChangePasswordPopup.vue?vue&type=template&id=4af5ccb2&"
import script from "./CMChangePasswordPopup.vue?vue&type=script&lang=js&"
export * from "./CMChangePasswordPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\DigitalCreditTransfer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4af5ccb2')) {
      api.createRecord('4af5ccb2', component.options)
    } else {
      api.reload('4af5ccb2', component.options)
    }
    module.hot.accept("./CMChangePasswordPopup.vue?vue&type=template&id=4af5ccb2&", function () {
      api.rerender('4af5ccb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/popups/user/CMChangePasswordPopup.vue"
export default component.exports